var render = function render(){var _vm=this,_c=_vm._self._c;return _c('range',{attrs:{"start":_vm.startDate,"end":_vm.endDate},on:{"picker":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }